import { useEffect, useState } from 'react'
import { Control, Controller, FieldValues, UseFormSetValue } from 'react-hook-form'
import { Checkbox, Flex, Slider, Typography } from 'antd'
import { IDistributedScale, IDistributedScaleAnswer } from '@/models'

interface IDistributedScaleForPairSelectionProps {
  question: IDistributedScale
  control: Control
  setValue: UseFormSetValue<FieldValues>
}

const DistributedScaleForPairSelection = ({ question, control, setValue }: IDistributedScaleForPairSelectionProps) => {
  const [scales, setScales] = useState<IDistributedScaleAnswer[][]>()
  const [disableScales, setDisableScales] = useState<boolean>(false)
  // const Styled = styled.div`
  //   .ant-tooltip-container {
  //     color: yellow;
  //     background-color: green;
  //     height: 30px;
  //     width: 30px;
  //     border-radius: 50%;
  //   }
  //   .ant-tooltip .ant-tooltip-arrow {
  //     display: none;
  //   }
  // `

  useEffect(() => {
    if (question.answers?.length) {
      const initSelectedRanges = {}
      const groupedScales = question?.answers?.reduce(
        (acc: IDistributedScaleAnswer[][] | [], value: IDistributedScaleAnswer, i: number) => {
          const index = Math.floor(i / 2)
          acc[index] = acc[index] || []
          acc[index][i % 2] = value
          return acc
        },
        []
      )

      new Array(groupedScales?.length)?.fill('')?.forEach((_, i: number) => (initSelectedRanges[i] = 0))
      setScales(groupedScales)
      groupedScales?.forEach((scale: IDistributedScaleAnswer[]) => {
        if (scale?.[0]?.title !== 'Затрудняюсь ответить' && scale?.[0]?.code !== 99)
          setValue(`${question.id}.${scale[0].uuid}split${scale[1].uuid}`, question?.balli)
      })
    }
  }, [question, setValue])

  return (
    <>
      {scales?.length &&
        scales?.map((scale: IDistributedScaleAnswer[]) =>
          scale[0].title !== 'Затрудняюсь ответить' && scale[0].code !== 99 ? (
            <Controller
              key={scale[0].uuid}
              name={`${question.id}.${scale[0].uuid}split${scale[1].uuid}`}
              control={control}
              render={({ field: { onChange } }) => (
                <Flex vertical gap={10}>
                  <Flex justify='space-between' gap={20}>
                    <Typography.Text>{scale[0].title}</Typography.Text>
                    <Typography.Text style={{ textAlign: 'end' }}>{scale[1].title}</Typography.Text>
                  </Flex>
                  {/* <Styled> */}
                  <Slider
                    // name={`${scale[0].uuid}split${scale[1].uuid}`}
                    styles={{
                      track: {
                        background: 'transparent'
                      },
                      // tracks: {
                      //   background: `linear-gradient(to right, ${getGradientColor(start)} 0%, ${getGradientColor(end)} 100%)`
                      // }
                      handle: {
                        zIndex: 2,
                        display: disableScales ? 'none' : 'block'
                      }
                    }}
                    marks={{
                      0: {
                        style: {
                          backgroundColor: scale[0].color,
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          zIndex: 1,
                          marginTop: '-21px'
                        },
                        label: <strong>0</strong>
                      },
                      [question.balli]: {
                        style: {
                          backgroundColor: scale[1].color,
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          zIndex: 1,
                          marginTop: '-21px'
                        },
                        label: <strong>{question.balli}</strong>
                      }
                    }}
                    min={0}
                    tooltip={{
                      open: !disableScales
                      // getPopupContainer: (triggerNode) => {
                      //   return triggerNode
                      // }
                    }}
                    // value={value || 0}
                    onChange={onChange}
                    max={question.balli}
                    defaultValue={(question.balli - 1) / 2}
                    // defaultValue={}
                    disabled={disableScales}
                    // onChange={onChange}
                  />
                  {/* </Styled> */}
                </Flex>

                // <Scale
                //   name={`${scale[0].uuid}split${scale[1].uuid}`}
                //   value={value || 0}
                //   onChange={onChange}
                //   count={question.balli}
                //   prefix={scale[0].title}
                //   suffix={scale[1].title}
                //   style={{ background: scale[0].color }}
                //   showSliderValue={false}
                //   disabled={disableScales}
                // />
              )}
            />
          ) : (
            <Controller
              name={`${question.id}.${scale[0].uuid}`}
              key={scale[0].uuid}
              control={control}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  checked={field.value === 99}
                  prefixCls='checkbox-scale'
                  onChange={(e) => {
                    if (e?.target?.checked) {
                      scales?.forEach((item: any) => {
                        if (item?.[0]?.uuid !== scale?.[0]?.uuid)
                          setValue(`${question?.id}.${item?.[0].uuid}split${item?.[1].uuid}`, undefined)
                        setValue(`${question?.id}.${scale?.[0].uuid}`, 99)
                      })
                      setDisableScales(true)
                    } else {
                      setValue(`${question?.id}.${scale?.[0]?.uuid}`, undefined)
                      setDisableScales(false)
                    }
                  }}
                  className='offset-top-30'
                >
                  Затрудняюсь ответить
                </Checkbox>
              )}
            />
          )
        )}
      <div />
    </>
  )
}

export default DistributedScaleForPairSelection
